module.exports = __webpack_public_path__ + "img/IR.071e5a5e.png";